import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import './Certifications.css';

const certifications = [
  {
    image: '/images/cert1.jpg',
    title: 'ISO 9001:2015',
    description: 'Quality Management System Certification',
  },
  {
    image: '/images/cert2.jpg',
    title: 'CE Certification',
    description: 'Conformité Européenne for Machinery Compliance',
  },
  {
    image: '/images/cert3.jpg',
    title: 'MSME Registration',
    description: 'Registered Micro, Small and Medium Enterprise',
  },
];

const Certifications = () => {
  return (
    <section id="certifications" className="cert-section" aria-labelledby="cert-title">
      <Helmet>
        <title>Certifications | UBR Engineering Works</title>
        <meta
          name="description"
          content="Explore the official certifications earned by UBR Engineering Works, including ISO 9001:2015, CE marking for machinery, and MSME registration."
        />
        <meta
          name="keywords"
          content="UBR Engineering certifications, ISO 9001, CE certification, MSME, quality management, machinery compliance"
        />
        <meta name="author" content="UBR Engineering Works" />
      </Helmet>

      <h2 id="cert-title" className="cert-title">Our Certifications</h2>
      <div className="cert-underline" aria-hidden="true"></div>

      <div className="cert-card-container" role="group" aria-label="Certifications List">
        {certifications.map((cert, index) => (
          <motion.div
            key={index}
            className="cert-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{
              scale: 1.05,
              boxShadow: '0 10px 24px rgba(0, 0, 0, 0.15)',
              border: '2px solid #00bcd4',
            }}
            transition={{ duration: 0.4, delay: index * 0.2 }}
            viewport={{ once: true }}
            aria-label={`${cert.title}: ${cert.description}`}
          >
            <img
              src={cert.image}
              alt={cert.title}
              className="cert-image"
              loading="lazy"
              decoding="async"
            />
            <h3 className="cert-card-title">{cert.title}</h3>
            <p className="cert-card-text">{cert.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Certifications;
